import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    window.machineGlider = ( typeof window.machineGlider != 'undefined' && window.machineGlider instanceof Array ) ? window.machineGlider : []

    let itemWidth = 320;
    let suffix = '';
    if ("width" in this.element.dataset) {
      itemWidth = this.element.dataset.width;
    }

    if ("suffix" in this.element.dataset) {
      suffix = this.element.dataset.suffix;
    }

    let glider = new Glider(this.element, {
      slidesToShow: 1,
      slidesToScroll: 1,
      scrollLock: true,
      draggable: true,
      arrows: {
        prev: '.glider-prev' + suffix,
        next: '.glider-next' + suffix
      },
      responsive: [
        {
          // screens greater than >= 775px
          breakpoint: 775,
          settings: {
            slidesToShow: 'auto',
            slidesToScroll: 'auto',
            itemWidth: itemWidth,
            duration: 0.25
          }
        }
      ]
    });
    window.machineGlider.push(glider);
  }
}
